export enum BannerType {
  Info = 'info',
  Warn = 'warn',
  None = 'none'
}
